import Axios from "axios";
var UpperSupCheckService = (function () {
    function UpperSupCheckService() {
    }
    UpperSupCheckService.prototype.getGroupchilds = function (params) {
        return Axios.get("supplierclientapi/supplierupper/category_list", { params: params });
    };
    UpperSupCheckService.prototype.getRecordList = function (params) {
        return Axios.get("supplierclientapi/upperstatementorder/receivable_list", { params: params });
    };
    UpperSupCheckService.prototype.getOrderList = function (params) {
        return Axios.get("supplierclientapi/upperstatementorder/list", { params: params });
    };
    UpperSupCheckService.prototype.audit = function (order_ids) {
        return Axios.get("supplierclientapi/upperstatementorder/audit", { params: { order_ids: order_ids } });
    };
    UpperSupCheckService.prototype.deleteOrder = function (order_ids) {
        return Axios.get("supplierclientapi/upperstatementorder/cancel", { params: { order_ids: order_ids } });
    };
    UpperSupCheckService.prototype.createAddInfo = function (params) {
        return Axios.get("supplierclientapi/upperstatementorder/create_info", { params: params });
    };
    UpperSupCheckService.prototype.create = function (data) {
        return Axios.post("supplierclientapi/upperstatementorder/create", data);
    };
    UpperSupCheckService.prototype.update = function (data) {
        return Axios.post("supplierclientapi/upperstatementorder/update", data);
    };
    UpperSupCheckService.prototype.getDetail = function (params) {
        return Axios.get("supplierclientapi/upperstatementorder/detail", { params: params });
    };
    UpperSupCheckService.prototype.getDepotOptions = function (params) {
        return Axios.get("supplierclientapi/upperstatementorder/depot_list", { params: params });
    };
    UpperSupCheckService.prototype.getStatus = function (params) {
        return Axios.get("supplierclientapi/upperstatementorder/get_order_status_list", { params: params });
    };
    UpperSupCheckService.prototype.realisticMoney = function (params) {
        return Axios.get("supplierclientapi/upper_payment_order/up_payment_statement_order", { params: params });
    };
    UpperSupCheckService.createInstance = function () {
        UpperSupCheckService.getInstance();
    };
    UpperSupCheckService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return UpperSupCheckService;
}());
export default UpperSupCheckService;
